export default class BatchPageOperationNotAllowedErrorHandler {
    /** @type {BatchPageHeaderCmp} */
    #headerCmp;

    constructor(headerCmp) {
        this.#headerCmp = headerCmp;
    }
    /**
     * @param {OperationNotAllowedError} error
     */
    handle(error) {
        this.#headerCmp.showReadOnlyModeIndicator();
    }
}